import { Anchor, Box, Tag } from '@zillow/constellation-10';
import { uniqBy } from 'lodash';
import React from 'react';

import { NON_GRAY_TONES, TagTone } from '../../../util/tagTones';
import { wrap } from '../../../util/wrap';

import { PostCategoriesProps } from './PostCategories.types';

const PostCategories: React.FC<PostCategoriesProps> = ({
    categories = [],
    primaryCategory,
}) => {
    if (!categories.length && !primaryCategory) {
        return null;
    }

    const uniqueCategories = uniqBy(
        primaryCategory ? [primaryCategory, ...categories] : categories,
        'id'
    ).filter(Boolean);

    return (
        <Box
            css={{
                marginBottom: 'default',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 'default',
            }}
        >
            {uniqueCategories.map((category, index) => (
                <Anchor
                    css={{ textDecoration: 'none' }}
                    key={category?.id}
                    href={category.link}
                >
                    <Tag
                        css={{ textTransform: 'none' }}
                        tone={
                            NON_GRAY_TONES[
                                wrap(0, NON_GRAY_TONES.length, index)
                            ] as TagTone
                        }
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: category.name,
                            }}
                        />
                    </Tag>
                </Anchor>
            ))}
        </Box>
    );
};

export default PostCategories;
